<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {},
  data() {
    return {
      msg: 'Welcome to Your Vue.js App',
    };
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue